import React, { FC } from 'react';

interface IconDoppleDirectProps {
  className?: string;
}

const IconDoppleDirect: FC<IconDoppleDirectProps> = (props: IconDoppleDirectProps) => {
  const { className } = props;

  return (
    <svg
      className={className}
      version="1.1"
      id="svg2"
      width="249.13333"
      height="249.33333"
      viewBox="0 0 249.13333 249.33333"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs6" />
      <g id="g8" transform="matrix(1.3333333,0,0,-1.3333333,0,249.33333)">
        <g id="g10" transform="scale(0.1)">
          <path
            d="m 481.656,496.129 c -15.804,-9.84 -31.5,-19.848 -47.433,-29.469 C 387.41,438.371 337.297,418.828 282.809,412.16 146.836,395.531 44.125,466.73 8.96484,601.449 -18.2383,705.66 16.4375,793.109 113.426,861.98 c 52.972,37.618 111.48,62.856 175.867,73.661 3.699,0.621 7.371,1.492 10.992,2.48 1.102,0.301 1.985,1.395 6.074,4.426 -8.531,2.383 -14.921,4.691 -21.507,5.93 -76.247,14.343 -145.965,42.543 -202.934,96.913 -68.6602,65.53 -94.7383,144.16 -66.9922,236.49 29.414,97.88 86.8082,168.37 194.3752,184.08 55.984,8.18 110.656,-0.86 162.742,-21.46 33.125,-13.1 64.445,-30.75 96.535,-46.45 4.77,-2.33 9.332,-5.09 17.168,-4.89 -5.668,9.98 -11.57,19.84 -16.973,29.97 -40.101,75.14 -65.082,153.81 -54.136,240.38 8.953,70.81 45.347,124.11 105.695,161.2 40.766,25.06 85.719,41.85 132.828,44.84 66.531,4.24 124.164,-21.85 171.688,-68.36 61.324,-60.02 91.722,-135.42 105.91,-218.5 1.097,-6.44 2.758,-12.78 8.488,-19.21 1.449,5.79 3.016,11.55 4.336,17.36 19.949,87.93 57.938,166.06 126.468,226.55 64.01,56.49 138.26,69.4 218.41,43.52 99.29,-32.04 166.7,-94.18 179.58,-203.06 7.95,-67.21 -9.09,-129.85 -39.84,-188.91 -14.66,-28.14 -32.21,-54.78 -46.81,-84.91 4.83,3.07 9.67,6.11 14.48,9.22 67.93,43.93 141.94,70.24 223.07,72.38 104.58,2.75 183.01,-48.17 222.4,-145.46 13.03,-32.2 26.12,-67 27.06,-100.95 2.29,-82.28 -37.45,-146.49 -101.53,-196.31 -54.5,-42.363 -117.6,-64.07 -184.53,-76.5 -4.92,-0.91 -9.83,-1.871 -14.69,-3.035 -1.07,-0.254 -1.9,-1.484 -5.25,-4.266 8.31,-2.367 14.5,-4.472 20.85,-5.894 69.29,-15.524 131.68,-45.625 186.82,-90.145 96.7,-78.082 118.32,-193.14 58.37,-306.679 C 1774.38,424 1671.79,378.23 1556.87,403.199 c -63.38,13.77 -119.32,42.012 -171.22,79.699 -6.48,4.711 -13.05,9.293 -23.29,11.051 4.06,-6.328 7.93,-12.777 12.19,-18.961 C 1425.2,401.559 1460.18,323.25 1456.2,231.16 1452.93,155.512 1421.8,95.4609 1360.1,52.2617 1302.4,11.8594 1237.58,-6.92188 1167.44,2.30859 1106.47,10.3398 1059.35,45.0313 1021.51,91.9805 974.914,149.801 944.848,215.551 931.516,288.789 c -0.981,5.391 -2.899,10.602 -8.121,16.152 -1.29,-5.613 -2.793,-11.171 -3.829,-16.832 C 907.648,222.941 884.938,162.301 844.852,108.84 764.051,1.05859 644.156,-25.3906 525.57,38.5195 419.367,95.75 377.297,198.5 408.422,324.102 c 14.039,56.648 35.617,109.878 69.82,157.57 2.485,3.469 4.235,7.457 6.324,11.199 -0.972,1.09 -1.941,2.168 -2.91,3.258"
            fill="#e5982d"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path12"
          />
          <path
            d="m 529.945,982.684 h 33.282 c 21.058,0 33.539,11.699 33.539,35.356 0,22.62 -15.078,34.32 -35.879,34.32 h -30.942 z m 0,85.796 h 27.559 c 18.203,0 30.426,11.7 30.426,31.72 0,19.77 -12.223,28.86 -30.426,28.86 H 529.945 Z M 509.402,965 v 181.48 h 47.067 c 30.156,0 53.039,-13.26 53.039,-45.5 0,-19.5 -9.36,-33.02 -27.82,-37.95 18.98,-2.61 36.66,-20.03 36.66,-44.99 0,-35.884 -22.098,-53.04 -54.864,-53.04 h -54.082"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path14"
          />
          <path
            d="m 716.883,1060.68 h 27.824 c 21.316,0 35.102,13.27 35.102,34.07 0,20.8 -13.786,34.31 -35.102,34.31 H 716.883 Z M 696.344,965 v 181.48 h 48.363 c 32.758,0 56.938,-18.97 56.938,-51.22 0,-24.18 -15.336,-41.85 -38.743,-45.49 13.266,-2.35 22.883,-9.89 27.043,-23.93 5.2,-17.94 2.078,-43.684 9.618,-60.84 h -21.317 c -5.98,14.297 -2.859,39 -7.281,55.9 -5.457,18.98 -22.879,22.1 -43.16,22.1 h -10.922 v -78 h -20.539"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path16"
          />
          <path
            d="m 913.965,1035.2 h 52.258 l -26.258,92.05 z m 72.277,-70.2 -15.074,52.78 H 909.023 L 893.945,965 h -21.582 l 53.039,181.48 h 29.641 L 1008.09,965 h -21.848"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path18"
          />
          <path
            d="m 1080.61,965 v 181.48 h 23.67 l 77.22,-152.878 c -1.82,8.838 -2.59,54.598 -2.59,70.198 v 82.68 h 20.8 V 965 h -24.19 l -77.22,153.93 c 1.56,-10.41 2.86,-50.97 2.86,-70.21 V 965 h -20.55"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path20"
          />
          <path
            d="m 1305.25,982.684 h 27.83 c 33.54,0 54.08,28.076 54.08,73.316 0,45.24 -20.54,73.06 -54.08,73.06 h -27.83 z M 1284.72,965 v 181.48 h 48.36 c 45.76,0 75.66,-37.18 75.66,-90.48 0,-53.3 -29.9,-91 -75.66,-91 h -48.36"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path22"
          />
          <path
            d="m 529.945,712.68 h 27.821 c 33.543,0 54.082,28.082 54.082,73.332 0,45.226 -20.539,73.047 -54.082,73.047 H 529.945 Z M 509.402,695 v 181.484 h 48.364 c 45.761,0 75.664,-37.175 75.664,-90.472 C 633.43,732.699 603.527,695 557.766,695 h -48.364"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path24"
          />
          <path
            d="M 694.777,695 V 876.484 H 715.32 V 695 h -20.543"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path26"
          />
          <path
            d="m 805.281,790.68 h 27.824 c 21.317,0 35.102,13.261 35.102,34.07 0,20.801 -13.785,34.309 -35.102,34.309 H 805.281 Z M 784.738,695 v 181.484 h 48.367 c 32.758,0 56.938,-18.972 56.938,-51.222 0,-24.18 -15.336,-41.852 -38.738,-45.5 13.258,-2.34 22.879,-9.883 27.039,-23.922 5.199,-17.942 2.082,-43.68 9.621,-60.84 h -21.32 c -5.981,14.301 -2.864,39 -7.282,55.898 C 853.906,769.879 836.484,773 816.203,773 h -10.922 v -78 h -20.543"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path28"
          />
          <path
            d="m 957.641,695 v 181.484 h 91.779 v -17.425 h -71.236 v -61.36 h 61.106 V 780.02 H 978.184 V 712.68 H 1050.2 V 695 h -92.559"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path30"
          />
          <path
            d="m 1104.54,785.738 c 0,54.864 30.16,93.871 72.8,93.871 35.36,0 61.88,-22.359 66.04,-68.129 l -20.8,-2.859 c -1.56,36.141 -21.32,53.57 -45.24,53.57 -30.16,0 -51.48,-31.722 -51.48,-76.453 0,-44.718 21.32,-76.179 53.04,-76.179 24.7,0 42.9,21.582 43.94,51.48 l 20.8,-1.559 c -2.34,-39.781 -27.56,-67.601 -64.74,-67.601 -44.2,0 -74.36,39.262 -74.36,93.859"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path32"
          />
          <path
            d="m 1340.36,695 v 164.059 h -49.14 v 17.425 h 119.08 v -17.425 h -49.14 V 695 h -20.8"
            fill="#fffbf5"
            fillOpacity={1}
            fillRule="nonzero"
            stroke="none"
            id="path34"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconDoppleDirect;
